import { Box, Container, Grid, Stack, useMediaQuery } from "@mui/material";
import axios from "axios";
import { url } from "../utils";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import WithdrawalTimer from "./Timer";
import Loading from "../loading";

export default function LiveProjects() {
  const matches = useMediaQuery("(max-width:750px)");

  const [Data, setData] = useState([]);
  const [findData, setfindData] = useState([]);
  const [loading, setloading] = useState(false);
  const initData = async () => {
    setloading(true);
    try {
      const { data } = await axios.get(`${url}/presaleRouter/IODData/`);
      setData(data.iod);
      setloading(false);
    } catch (error) {}
    setloading(false);
  };
  useEffect(() => {
    initData();
  }, []);
  useEffect(() => {
    setloading(true);
    try {
      const init = async () => {
        let findDataServer = await Data.filter(
          ({ projectStatus }) => projectStatus == "open"
        );
        setfindData(findDataServer);
        setloading(false);
      };
      if (Data.length > 0) {
        init();
      }
    } catch (error) {}
    setloading(false);
  }, [Data]);

  return (
    <Box id="liveprojects" my={matches ? 4 : 10}>
      <Loading loading={loading} />
      <Container maxWidth="lg">
        <Box
          mb={5}
          textAlign="center"
          fontSize="30px"
          fontWeight="700"
          fontFamily="Raleway"
        >
          Live Projects
        </Box>
        <Grid container spacing={5} justifyContent="center">
          {findData.length > 0 ? (
            findData.map((item, index) => (
              <Grid key={index} item xs={12} sm={4}>
                <Link
                  style={{ width: "100%" }}
                  to={`/projectdetails/${item._id}`}
                >
                  <Box bgcolor="#271942" borderRadius="15px">
                    <Box
                      position="relative"
                      height="204px"
                      borderRadius="15px"
                      style={{
                        background: `url(${item.coverImage})`,
                        backgroundPosition: "cover",
                        backgroundSize: "100% 100%",
                      }}
                    >
                      <Box
                        position="absolute"
                        top="65%"
                        left="10%"
                        width="93px"
                        height="93px"
                        border="6px solid #1B202C"
                        borderRadius="15px"
                        style={{
                          background: `url(${item.logoLink})`,
                          backgroundPosition: "cover",
                          backgroundSize: "100% 100%",
                        }}
                      ></Box>
                    </Box>
                    <Stack
                      mt={4}
                      mx="auto"
                      direction="row"
                      justifyContent="space-between"
                      width="80%"
                    >
                      <Box
                        fontFamily="Raleway"
                        color="#fff"
                        fontSize="1rem"
                        fontWeight="500"
                      >
                        <Box fontSize="1.5625rem">{item.projectName}</Box>
                        <Box color="#717988">{item.tokenSymbol}</Box>
                      </Box>
                      <Box>
                        <img width="40px" src={item.logoLink} />
                      </Box>
                    </Stack>
                    <Stack
                      mt={2}
                      mx="auto"
                      direction="row"
                      justifyContent="space-between"
                      width="80%"
                      color="#fff"
                      fontSize="15px"
                      fontWeight="500"
                    >
                      <Box fontFamily="Raleway">Presale Price</Box>

                      <Box fontFamily="Open Sans">{item.presaleRate}</Box>
                    </Stack>

                    <Stack
                      mx="auto"
                      mt={1}
                      direction="row"
                      justifyContent="space-between"
                      width="80%"
                      color="#fff"
                      fontSize="15px"
                      fontWeight="500"
                    >
                      <Box fontFamily="Raleway">Project Status</Box>

                      <Box fontFamily="Raleway">{item.projectStatus}</Box>
                    </Stack>
                    <Stack
                      pb={4}
                      mx="auto"
                      mt={1}
                      direction="row"
                      justifyContent="space-between"
                      width="80%"
                      color="#fff"
                      fontSize="15px"
                      fontWeight="500"
                      alignItems="center"
                    >
                      <Box fontFamily="Raleway">End Time</Box>

                      <Box fontFamily="Open Sans">
                        <WithdrawalTimer endTime={+item.endTime} />
                      </Box>
                    </Stack>
                  </Box>
                </Link>
              </Grid>
            ))
          ) : loading ? (
            loading
          ) : (
            <Box
              width="100%"
              display="flex"
              alignItems="center"
              flexDirection="column"
            >
              <Box
                mt={5}
                borderRadius="10px"
                px={3}
                py={2}
                ml={matches ? 0 : 4}
                boxShadow="rgba(0, 0, 0, 0.35) 0px 0px 15px 5px"
                fontWeight={500}
                fontSize="20px"
                fontFamily="Raleway"
              >
                There is no Live Project yet
              </Box>
            </Box>
          )}
        </Grid>
      </Container>
    </Box>
  );
}
